export default __webpack_public_path__ + "static/media/progress-b-m.e9e1bd61.svg";